$(function(){
    if($(".page--range").length != 0){

         $('.model-row').click(function(){
            var href = $(this).attr('href');
            window.location.href = href;
         });
    }
});


